import { render, staticRenderFns } from "./PercentageTable.vue?vue&type=template&id=dabd3dfa&scoped=true&"
import script from "./PercentageTable.vue?vue&type=script&lang=ts&"
export * from "./PercentageTable.vue?vue&type=script&lang=ts&"
import style0 from "./PercentageTable.vue?vue&type=style&index=0&id=dabd3dfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabd3dfa",
  null
  
)

export default component.exports